
export function formatData(data= {}) {
  const { chartData = null, isFetching, errorMsg = '', metricValue = {} } = (data as any);

  return {
    chartData,
    isLoading: isFetching,
    isError: errorMsg.length !== 0,
    isEmpty: !('humanizedNumber' in metricValue)
  }
}
